import { shallowEqual } from 'react-redux';
import { Alert, CloseButton, ModalTrigger, TextButton } from '@zillow/constellation-10';

import { useSelector } from '../../selectors/useSelector';
import CorrectMapPinCSEvents from '../../model/ClickstreamEvent/CorrectMapPinCSEvents';
import MapPinAdjustmentRequestModal from '../Modal/MapPinAdjustmentRequestModal';

const MapPinAdjustmentAlert = () => {
  const { canSubmitMapPinRequest, user, currentProperty } = useSelector(
    (state) => ({
      canSubmitMapPinRequest: state.properties.currentProperty.canSubmitMapPinRequest,
      user: state.user,
      currentProperty: state.properties.currentProperty,
    }),
    shallowEqual,
  );

  const handleClick = () => {
    CorrectMapPinCSEvents.ClickCorrectMapPinLocationFromPostingPath({ user, currentProperty });
  };

  return canSubmitMapPinRequest ? (
    <>
      <Alert
        tone="warning"
        role="alert"
        actionButton={
          <ModalTrigger multiModalTriggerId="MapPinAdjustmentRequestModal">
            <TextButton
              onClick={handleClick}
              data-eventid={CorrectMapPinCSEvents.ClickCorrectMapPinLocationFromPostingPath.data_event_id}
            >
              Correct map pin location
            </TextButton>
          </ModalTrigger>
        }
        closeButton={<CloseButton />}
        css={{
          marginBottom: '600',
        }}
      >
        Your property location may be incorrect. Contact us to fix it.
      </Alert>
      <MapPinAdjustmentRequestModal isFromPostingPath={true} />
    </>
  ) : null;
};

export default MapPinAdjustmentAlert;
